// src/Components/Common/JobErrorLogList.tsx
// Hiển thị lịch sử lỗi (bao gồm cả lỗi "stalled" do StalledJobWatchdogService phát hiện) của
// 1 background job — dùng chung cho panel Sinh Bộ Số & QR và panel export gói in.
import React, { useState } from 'react';
import { Spinner } from 'reactstrap';
import moment from 'moment';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('component_job_error_log_list');

interface JobErrorLogEntry {
  id: number;
  jobId: string;
  errorSource: string;
  errorMessage: string;
  occurredAt: string;
}

interface JobErrorLogListProps {
  fetchLogs: () => Promise<any>;
}

const JobErrorLogList: React.FC<JobErrorLogListProps> = ({ fetchLogs }) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState<JobErrorLogEntry[] | null>(null);

  const handleToggle = async () => {
    const next = !expanded;
    setExpanded(next);
    if (next && logs === null) {
      setLoading(true);
      try {
        const response = await fetchLogs();
        const payload = (response as any)?.data || response;
        setLogs(Array.isArray(payload) ? payload : []);
      } catch {
        setLogs([]);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="mt-2">
      <button
        type="button"
        className="btn btn-link btn-sm p-0 text-decoration-none"
        onClick={handleToggle}
      >
        {expanded ? st('an_lich_su_loi_text') : st('xem_lich_su_loi_text')}
      </button>
      {expanded && (
        <div className="mt-2 border rounded p-2 bg-light" style={{ maxHeight: 180, overflowY: 'auto' }}>
          {loading ? (
            <div className="text-center py-2">
              <Spinner size="sm" />
            </div>
          ) : !logs || logs.length === 0 ? (
            <div className="text-muted small">{st('khong_co_lich_su_loi_text')}</div>
          ) : (
            logs.map((log) => (
              <div key={log.id} className="small mb-2 pb-2 border-bottom">
                <div className="d-flex justify-content-between gap-2">
                  <span className={`fw-semibold ${log.errorSource === 'Stalled' ? 'text-warning' : 'text-danger'}`}>
                    {log.errorSource === 'Stalled' ? st('dung_dot_ngot_text') : st('loi_text')}
                  </span>
                  <span className="text-muted text-nowrap">{moment(log.occurredAt).format('DD/MM/YYYY HH:mm:ss')}</span>
                </div>
                <div className="text-break">{log.errorMessage}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default JobErrorLogList;
